"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var pokeapi_js_wrapper_1 = require("pokeapi-js-wrapper");
var utils_1 = require("./utils");
var type_to_nodes_1 = require("./type_to_nodes");
var simulation_1 = require("./simulation");
var pokedex = new pokeapi_js_wrapper_1.Pokedex({
    protocol: 'https',
    cache: true,
    timeout: 5 * 1000,
});
function id(x) {
    return x;
}
function preloadData(nodes) {
    nodes.map(function (node) {
        pokedex.getTypeByName(node.name);
    });
}
function updateVisualisation(svg, focused, title, forceSimulation, focusedUpdated) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, response, nodes, simulation;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = utils_1.boundingDimensions(svg), width = _a.width, height = _a.height;
                    svg.setAttribute('width', width.toString());
                    svg.setAttribute('height', height.toString());
                    updateFocused(svg, focused);
                    updateTitle(svg, title);
                    if (!focusedUpdated) return [3 /*break*/, 2];
                    return [4 /*yield*/, pokedex.getTypeByName(focused)];
                case 1:
                    response = _b.sent();
                    nodes = type_to_nodes_1.default(response);
                    preloadData(nodes);
                    simulation = forceSimulation(svg);
                    simulation.nodes(nodes);
                    simulation_1.tick(simulation);
                    updateCircles(svg, simulation);
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
exports.updateVisualisation = updateVisualisation;
function updateFocused(svg, focused) {
    updateTextElement(svg, focused, 'focused', 0.5, 0.5);
}
function updateTitle(svg, title) {
    updateTextElement(svg, title, 'title', 0.5, 0.125);
}
function updateTextElement(svg, text, className, xMultiple, yMultiple) {
    var _a = utils_1.boundingDimensions(svg), width = _a.width, height = _a.height;
    var updating = d3.select(svg)
        .selectAll("." + className)
        .data([text], function (d) { return d; });
    updating
        .enter()
        .append('text')
        .merge(updating)
        .classed(className, true)
        .attr('x', width * xMultiple)
        .attr('y', height * yMultiple)
        .text(id);
    updating
        .exit()
        .remove();
}
function updateCircles(svg, simulation) {
    var nodeTransition = d3.transition()
        .duration(600);
    var updatingNodes = d3.select(svg)
        .selectAll('circle')
        .data(simulation.nodes(), function (d) {
        return d.name + "-" + d.direction;
    });
    var enteringNodes = updatingNodes
        .enter()
        .append('circle');
    var mergedNodes = enteringNodes
        .merge(updatingNodes);
    var exitingNodes = updatingNodes
        .exit();
    enteringNodes
        .attr('class', function (d) { return d.name; })
        .attr('cx', function (d) { return d.x; })
        .attr('cy', function (d) { return d.y; })
        .on('click', function (d) {
        if (utils_1.focusedType() === d.name) {
            return;
        }
        utils_1.updateFocusedType(d.name);
        utils_1.updateHoveredNode(undefined);
        this.dispatchEvent(new Event('mouseout'));
    })
        .on('mouseover', function (d) { return utils_1.updateHoveredNode(d); })
        .on('mouseout', function (d) { return utils_1.updateHoveredNode(undefined); })
        .attr('r', 0);
    mergedNodes
        .transition(nodeTransition)
        .attr('cx', function (d) { return d.x; })
        .attr('cy', function (d) { return d.y; })
        .attr('r', function (d) { return simulation_1.nodeRadius(d, svg); });
    exitingNodes
        .transition(nodeTransition)
        .attr('r', 0)
        .remove();
}
//# sourceMappingURL=update_visualisation.js.map